import React, { ReactNode } from "react";
import { useStoreState } from "ezStore";

import { IconButton } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

import { useUserFavorites } from "components/hooks/useUserFavorites";
import { FavoriteType } from "__generated__/graphql";
import { getFavorites } from "./utils";

import "./styling/selects.scss";

interface FavoriteSelectOptionProps {
	entityId: number;
	entityType: FavoriteType;
	subtitle?: string;
	title?: string
	children: ReactNode;
}

const FavoriteSelectOption = ({ entityId, entityType, subtitle, title, children }: FavoriteSelectOptionProps) => {

	const sessionFavorties = useStoreState((store) => store.session.user?.properties.favorites);
	const changeFavorite = useUserFavorites();

	const onToggle = (event: React.MouseEvent<HTMLAnchorElement>) => {
		event.preventDefault();
		event.stopPropagation();
		void changeFavorite({ entityId: entityId, entityType: entityType });
	};

	const favorites = getFavorites(sessionFavorties ?? [], entityType);
	const isFavorite = favorites.some(favorite => favorite.entityId === entityId);

	return (
		<div className={`favorite-select-option ${isFavorite ? "isFavorite" : ""}`}>
			<div>
				{title && <small>{title}</small>}
				<span>{children}</span>
				{subtitle && <small>{subtitle}</small>}
			</div>

			<span onClick={onToggle}>
				<IconButton size="small">
					{isFavorite ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
				</IconButton>
			</span>
		</div>
	);
};

export default FavoriteSelectOption;
